/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideExpenseDetails } from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";
import InputTextarea from "../../inputs/inputTextarea";
import price from "../../../Assets/images/price.png";
import InputCalender from "../../inputs/inputCalender";
const ShowDetailsExpense = ({ isOpenDetails, setOpenDetails, toggleModal }) => {
  //view pupup when onclick "اضافه مصروف"
  const expensess = useSelector((state) => state.expenses.expensess);
  const dispatch = useDispatch();
  const hidePupup = () => {
    dispatch(hideExpenseDetails());
  };

  return (
    <Popup
      viewPupup={isOpenDetails}
      hidePupup={toggleModal}
      viewWidth='content-xl'>
      <div className='head-content'>
        <div className='view-img'>
          <img src={price} alt='price' />
        </div>
      </div>
      <div className='body-content'>
        <div className='show-details'>
          <div className='item-details'>
            <h3>تاريــــخ الصرف :</h3>
            <p>{expensess.created_at?.slice(0, 10)}</p>
          </div>
          <div className='item-details'>
            <h3>اسم المصروف له :</h3>
            <p>{expensess?.driver?.name}</p>
          </div>
          <div className='item-details'>
            <h3> نوع الصرف :</h3>
            <p>{expensess.type}</p>
          </div>
          <div className='item-details'>
            <h3>قيمة الصرف :</h3>
            <p> {expensess.amount} د.ك</p>
          </div>
          <div className='item-details'>
            <h3> ملاحظات :</h3>
            <p>
              {expensess.notes === null ? "لا يوجد ملاحظات" : expensess.notes}
            </p>
          </div>
        </div>
      </div>

      <div class='btn btn__danger' onClick={() => setOpenDetails(false)}>
        الغاء
      </div>
    </Popup>
  );
};

export default ShowDetailsExpense;
